/** Global polite/assertive live regions — registered once by `A11yLiveRegion.vue`. */

let politeEl: HTMLElement | null = null;
let assertiveEl: HTMLElement | null = null;

export function registerA11yLiveRegions(
  polite: HTMLElement,
  assertive?: HTMLElement | null,
): void {
  politeEl = polite;
  assertiveEl = assertive ?? null;
}

export function unregisterA11yLiveRegions(): void {
  politeEl = null;
  assertiveEl = null;
}

/**
 * Announce a status message without moving focus (WCAG 4.1.3).
 * Region must already exist in the DOM at page load.
 */
export function announceA11yMessage(
  message: string,
  priority: "polite" | "assertive" = "polite",
): void {
  if (typeof document === "undefined" || !message.trim()) return;
  const el = priority === "assertive" ? (assertiveEl ?? politeEl) : politeEl;
  if (!el) return;
  el.textContent = "";
  void el.offsetHeight;
  el.textContent = message;
}

export function focusMainContent(): void {
  if (typeof document === "undefined") return;
  const main =
    document.getElementById("main-content") ??
    document.querySelector("main.app-main-content");
  if (!(main instanceof HTMLElement)) return;
  if (!main.hasAttribute("tabindex")) {
    main.setAttribute("tabindex", "-1");
  }
  main.focus({ preventScroll: false });
  main.scrollIntoView({ behavior: "smooth", block: "start" });
}
